'use strict';
define([
    'angular',
    'modules/access/reset/reset.controller',
],function(angular, ResetController){
    var app = angular.module('access.reset', []);
    app.controller('ResetController', ResetController);
    return app;
});